import ParameterErrors from '../errors/ParameterErrors';
import Vector3 from '../geometry/Vector3';
const { throwNotProvided } = ParameterErrors;
export default class Mesh {
    constructor(props) {
        const { name, material, position, relativePath} = props;
        if (!name) throwNotProvided("name");
        this._name = name;
        //if (!material) throwNotProvided("material");
        this._material = material;

        if (!position) throwNotProvided("position");
        this._position = position;
		
		this._relativePath = relativePath;
    }
    get name() {
        return this._name;
    }
    get material() {
        return this._material;
    }
    get position() {
        return this._position;
    }
    static fromObj(obj) {
        return new Mesh({
            name: obj.name,
            material: obj.material,
            position: Vector3.fromArray(obj.position),
			relativePath:obj.relativePath
        })
    }
}
